import Link from "next/link";
import Image from "next/image";
import { MessageCircleIcon, PhoneIcon, MailIcon, MapPinIcon } from "./Icons";

export default function Footer() {
  return (
    <footer className="footer" id="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Image
              src="/future_logo.png"
              alt="Future Institute Logo"
              width={180}
              height={60}
              style={{ objectFit: "contain" }}
            />
            <p>
              Future Institute has been a trusted name in distance education
              since 2005. We are an authorized Spot & Online Admission Center
              for leading universities in South India.
            </p>
            <div className="footer-social">
              <a
                href="https://wa.me/917902222553"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                id="footer-whatsapp"
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
              >
                <MessageCircleIcon size={18} style={{ strokeWidth: 2.5 }} />
              </a>
              <a 
                href="tel:+917902222553" 
                aria-label="Phone" 
                id="footer-phone"
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
              >
                <PhoneIcon size={18} style={{ strokeWidth: 2.5 }} />
              </a>
              <a
                href="mailto:info@futureinstitute.in"
                aria-label="Email"
                id="footer-email"
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
              >
                <MailIcon size={18} style={{ strokeWidth: 2.5 }} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <Link href="/">Home</Link>
            <Link href="/about">About Us</Link>
            <Link href="/courses">Our Courses</Link>
            <Link href="/universities">Universities</Link>
            <Link href="/contact">Contact Us</Link>
          </div>

          {/* Universities */}
          <div className="footer-links">
            <h4>Universities</h4>
            <Link href="/universities/msu">Manonmaniam Sundaranar University</Link>
            <Link href="/universities/madras">University of Madras</Link>
            <Link href="/universities/pondicherry">Pondicherry University</Link>
            <Link href="/universities/mku">Madurai Kamaraj University</Link>
            <Link href="/courses">UG Programmes</Link>
            <Link href="/courses">PG Programmes</Link>
            <Link href="/courses">MBA Programmes</Link>
          </div>

          {/* Contact */}
          <div className="footer-links">
            <h4>Contact Us</h4>
            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <MapPinIcon size={16} style={{ strokeWidth: 2.5 }} />
              </div>
              <div className="footer-contact-text">
                Near Malayala Manorama Office,
                <br />
                Opp. Central Residency Hotel,
                <br />
                Thampanoor, Trivandrum - 695001
              </div>
            </div>
            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <PhoneIcon size={16} style={{ strokeWidth: 2.5 }} />
              </div>
              <div className="footer-contact-text">
                <a href="tel:+917902222552">+91 79022 22552</a> |{" "}
                <a href="tel:+917902222553">+91 79022 22553</a>
                <br />
                <a href="tel:+919142222552">+91 91422 22552</a> |{" "}
                <a href="tel:+917902322552">+91 79023 22552</a>
              </div>
            </div>
            <div className="footer-contact-item">
              <div className="footer-contact-icon">
                <MessageCircleIcon size={16} style={{ strokeWidth: 2.5 }} />
              </div>
              <div className="footer-contact-text">
                WhatsApp:{" "}
                <a
                  href="https://wa.me/917902222553"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +91 79022 22553
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Future Institute. All Rights Reserved. |{" "}
            <a
              href="https://www.futureinstitute.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.futureinstitute.in
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
